<div class="flex flex-col gap-y-2 max-h-full overflow-hidden">
  <form
    [formGroup]="form"
    (ngSubmit)="save()"
    class="flex-1 overflow-hidden flex flex-col rounded-lg border border-slate-200 p-4 bg-amber-50"
  >
    <div class="flex items-start justify-between gap-3 mb-4">
      <h2 class="text-lg font-semibold text-slate-800 m-0">Basic Details</h2>
      <p-button type="submit" label="Save Package" size="small" [disabled]="!isFormValid()" />
    </div>

    <div class="flex-1">
      <div class="grid 2xl:grid-cols-4 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5">
        <div class="min-w-0">
          <p-floatlabel variant="on">
            <input type="text" pInputText size="small" class="w-full" formControlName="packageName" />
            <label for="packageName">Package Name <span class="text-red-500">*</span></label>
          </p-floatlabel>
        </div>

        <div class="min-w-0">
          <p-floatlabel variant="on">
            <generic-dropdown
              class="w-full"
              [placeholder]="''"
              [items]="projects()"
              [allowSearch]="true"
              [clearable]="false"
              formControlName="projectId"
            />
            <label for="projectId">Project <span class="text-red-500">*</span></label>
          </p-floatlabel>
        </div>

        <div class="min-w-0">
          <p-floatlabel variant="on">
            <generic-dropdown
              class="w-full"
              [placeholder]="''"
              [items]="modelElevationItems()"
              [allowSearch]="true"
              [clearable]="false"
              [disabled]="!selectedProjectIdSig() || modelElevationsResource.isLoading()"
              formControlName="elevationId"
            />
            <label for="elevationId">Model(Elevation) <span class="text-red-500">*</span></label>
          </p-floatlabel>
        </div>

        <div class="flex min-w-0 flex-col gap-1.5">
          <p-floatlabel variant="on">
            <input
              type="number"
              pInputText
              size="small"
              class="w-full"
              min="0"
              max="100"
              formControlName="discountPercentage"
            />
            <label for="discountPercentage">Discount Percentage</label>
          </p-floatlabel>
          @if (
            (form.controls.discountPercentage.hasError('min') || form.controls.discountPercentage.hasError('max')) &&
            (form.controls.discountPercentage.dirty || form.controls.discountPercentage.touched)
          ) {
            <small class="text-red-500">Discount percentage must be between 0 and 100.</small>
          }
          <span class="text-sm text-slate-500">Applied equally to all added options</span>
        </div>
      </div>
    </div>
  </form>
</div>
